import { FC, useEffect } from 'react';
import { postError } from 'wisestep-api';
import { Error } from 'wisestep-base';

export interface LoggerProps {
  error?: Error;
  pageRefresh?: boolean;
}
const ErrorLogger: FC<LoggerProps> = ({ error, pageRefresh }) => {
  useEffect(() => {
    const loggerFunction = async () => {
      if (error) {
        postError({
          message: error.message,
          name: error.name,
          url: document.URL,
          lineNo: error.stack,
          colno: error.cause,
          stack: error.stack,
        });
      }
    };
    loggerFunction();
  }, [error]);
  return (
    <>
      <Error pageRefresh={pageRefresh} />
    </>
  );
};
export default ErrorLogger;
